class CustomEngraving2026Icon extends HTMLElement {
  constructor() {
    super();
    this.customizationOptions = document.querySelector(
      "custom-engraving-2026-customization-options",
    );
    this.customEngraving2026 = document.querySelector("custom-engraving-2026");
  }

  connectedCallback() {
    this.icons = this.querySelector("#engraving-custom-icons--icon-inputs");
    this.optionsScreenBtn = this.querySelector(".go-to-options-screen");
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector("#engraving-custom-icon-submit");
    this.submitButtonLabel = this.submitButton.querySelector("span");
    this.status = this.querySelector("#engraving-icon-form-status");

    this.loadComponent();
    document.addEventListener(
      "custom-engraving-2026",
      this.customEngraving2026EventHandler.bind(this),
    );

    this.optionsScreenBtn.addEventListener("click", () => {
      this.resetSelection();
      this.customizationOptions.scrollToOptionsScreen();
    });
    this.icons.addEventListener("input", this.renderIcon.bind(this));
    this.form.addEventListener("submit", this.formSubmit.bind(this));
  }

  customEngraving2026EventHandler(event) {
    this.loadComponent(event.detail);
  }

  loadComponent(eventProductEngravingSettings = false) {
    const settings = eventProductEngravingSettings
      ? eventProductEngravingSettings
      : this.customEngraving2026.currentProductEngravingSettings;
    if (!settings) return;

    const { engravingService, currentProductInfo } = settings;
    this.engravingService = engravingService;
    if (engravingService.engravingType !== "caseback") {
      this.icons.replaceChildren();
      this.clearMessage();
      this.submitButton.disabled = true;
      return;
    }
    this.buildIconsMarkup(engravingService);
    this.setEngravingVariantId(engravingService);
    this.setCurrentProductVariantId(currentProductInfo);
  }

  setCurrentProductVariantId({ variantId }) {
    this.form.querySelector("input[data-pdp-variant-id]").value = variantId;
  }

  setEngravingVariantId({ engravingServiceProduct }) {
    this.form.querySelector("input[data-engraving-service-variant-id]").value =
      engravingServiceProduct;
  }

  buildIconsMarkup({ customIcons = [] }) {
    this.icons.replaceChildren();
    this.clearMessage();
    this.submitButton.disabled = true;
    this.submitButtonLabel.textContent = "Add Engraving";
    this.form.setAttribute("aria-busy", "false");
    this.isSubmitting = false;
    this.customizationOptions.resetCasebackPreview();
    this.customizationOptions.placeholderIcon.src =
      this.customizationOptions.placeholderIconURL;
    this.customizationOptions.placeholderIcon.alt = "Engraving Icon";

    if (!customIcons.length) {
      this.showMessage(
        "Custom icons are temporarily unavailable. Please go back and choose text engraving.",
      );
      return;
    }

    customIcons.slice(0, 3).forEach((item, index) => {
      const iconId = `custom-engraving-icon-${index + 1}`;
      const label = document.createElement("label");
      label.htmlFor = iconId;

      const image = document.createElement("img");
      image.src = item.url;
      image.alt = item.label;
      image.width = 100;
      image.height = 100;

      const title = document.createElement("span");
      title.textContent = item.label;

      const input = document.createElement("input");
      input.type = "radio";
      input.id = iconId;
      input.value = item.url;
      input.name = "custom-engraving-icon";
      input.dataset.label = item.label;
      input.required = true;

      image.addEventListener("error", () => {
        input.disabled = true;
        input.checked = false;
        label.classList.add("is-unavailable");
        title.textContent = `${item.label} unavailable`;
        this.submitButton.disabled = !this.icons.querySelector(
          'input[name="custom-engraving-icon"]:checked:not(:disabled)',
        );
        this.showMessage(
          "One of the icon previews couldn't load. Please choose another icon or try again.",
        );
      });

      label.append(image, title, input);
      this.icons.append(label);
    });
  }

  renderIcon(event) {
    this.clearMessage();
    const iconLabel = event.target.dataset.label || "Selected caseback";
    this.customizationOptions.placeholderCaseback.src = event.target.value;
    this.customizationOptions.placeholderCaseback.alt =
      `${iconLabel} engraved caseback preview`;
    this.customizationOptions.placeholderIcon.style.display = "none";
    this.submitButton.disabled = false;
  }

  resetSelection() {
    this.form.reset();
    this.clearMessage();
    this.submitButton.disabled = true;
    this.submitButtonLabel.textContent = "Add Engraving";
    this.customizationOptions.resetCasebackPreview();
    this.customizationOptions.placeholderIcon.src =
      this.customizationOptions.placeholderIconURL;
    this.customizationOptions.placeholderIcon.alt = "Engraving Icon";
    this.customizationOptions.placeholderIcon.style.display = "none";
  }

  async formSubmit(event) {
    event.preventDefault();
    if (this.isSubmitting || this.engravingService?.engravingType !== "caseback") return;

    const formEntries = Object.fromEntries(new FormData(this.form).entries());
    const selectedIcon = this.icons.querySelector(
      'input[name="custom-engraving-icon"]:checked',
    );

    if (!selectedIcon) {
      this.showMessage("Please select an icon before adding the engraving.");
      return;
    }

    if (
      !formEntries["pdp-variant-id"] ||
      !formEntries["engraving-service-variant-id"]
    ) {
      this.showMessage(
        "Engraving is temporarily unavailable for this watch. Please close this window and try again.",
      );
      return;
    }

    const cart = document.querySelector("cart-drawer");
    const cartSettings = this.buildCartSettings(formEntries, selectedIcon);
    const cartRequest = this.customEngraving2026.buildCartRequest(
      cartSettings,
      cart,
    );

    this.setSubmitting(true);

    try {
      const request = await fetch(
        window.Shopify.routes.root + cartRequest.endpoint,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(cartRequest.payload),
        },
      );

      const response = await request.json().catch(() => null);
      if (!request.ok) {
        throw new Error(
          response?.description ||
            `${cartRequest.endpoint} ${request.status}`,
        );
      }
      if (cartRequest.endpoint === "cart/add.js" && !response?.items?.length) {
        throw new Error("The cart response did not include an added item.");
      }

      this.customEngraving2026.renderCartResponse(
        response,
        cart,
        "custom-engraving-2026-icon",
      );
      this.resetElements();
      document.querySelector("#custom-engraving-2026--dialog")?.close();
    } catch (error) {
      console.error("Custom icon engraving add-to-cart failed:", error);
      this.showMessage(
        "We couldn't add the engraving. Please check your connection and try again.",
      );
    } finally {
      this.setSubmitting(false);
    }
  }

  buildCartSettings(formEntries, selectedIcon) {
    const iconLabel = selectedIcon?.dataset.label || "Custom Icon";

    return {
      id: `${formEntries["pdp-variant-id"]}`,
      quantity: 1,
      properties: {
        Engraving: `Custom Icon - ${iconLabel}`,
        _engraving_service_variant_id: `gid://shopify/ProductVariant/${formEntries["engraving-service-variant-id"]}`,
        _engraving_service_price: "39.00",
        _engraving_mode: "template",
        _engraving_type: "caseback",
        _engraving_customization_option: "custom-icon",
        _engraving_template_id: iconLabel,
        _engraving_icon_url: `${formEntries["custom-engraving-icon"]}`,
      },
    };
  }

  resetElements() {
    this.form.reset();
    this.clearMessage();
    this.submitButton.disabled = true;
    this.submitButtonLabel.textContent = "Add Engraving";
    this.form.setAttribute("aria-busy", "false");
    this.isSubmitting = false;
    this.customizationOptions.resetElements();
  }

  setSubmitting(isSubmitting) {
    this.isSubmitting = isSubmitting;
    this.form.setAttribute("aria-busy", isSubmitting ? "true" : "false");
    const hasSelectedIcon = this.icons.querySelector(
      'input[name="custom-engraving-icon"]:checked:not(:disabled)',
    );
    this.submitButton.disabled = isSubmitting || !hasSelectedIcon;
    this.submitButtonLabel.textContent = isSubmitting
      ? "Adding…"
      : "Add Engraving";
  }

  clearMessage() {
    if (!this.status) return;
    this.status.hidden = true;
    this.status.textContent = "";
  }

  showMessage(message) {
    if (!this.status) return;
    this.status.textContent = message;
    this.status.hidden = false;
    this.status.focus();
  }
}

customElements.define("custom-engraving-2026-icon", CustomEngraving2026Icon);
